// import { eventBus, EVENTS } from './EventBus.js';
const INITIAL_POS = 0;
const TOLERANCE = 20;
const TRANSITION_DURATION=600;
const SLIDER_TIMING=7000;
const scrollArr=[];
let interval;
let intervalInitiator = false;
let handling = false;
let data = {
  xPos: INITIAL_POS,
  partialXPos: INITIAL_POS,
  yPos: INITIAL_POS,
  partialYPos: INITIAL_POS,
  removed: false,
  ended: false
};
let root = document.documentElement;
let lastBreakpoint;
const DIRECTIONS = {
  LEFT: { touchClient: 'clientX', checkHandleCondition: diff => diff < 0, pos: 'xPos', partialPos: 'partialXPos', name: 'left' },
  RIGHT: {
    touchClient: 'clientX',
    checkHandleCondition: diff => diff > 0,
    pos: 'xPos',
    partialPos: 'partialXPos',
    name: 'right'
  }
  // TOP: { touchClient: 'clientY', checkHandleCondition: diff => diff < 0, pos: 'yPos', partialPos: 'partialYPos', name: 'top' },
  // BOTTOM: { touchClient: 'clientY', checkHandleCondition: diff => diff > 0, pos: 'yPos', partialPos: 'partialYPos', name: 'bottom' }
};

class Slider {
  constructor({total, paginator_cont, cssVar, slide_cont, swipeElementSelector}){
    this.total=total;
    this.paginator_cont=paginator_cont;
    this.cssVar=cssVar;
    this.slide_cont=slide_cont;


    this.swipeElementSelector=swipeElementSelector;
    this.container=$(this.swipeElementSelector);
    this.images=this.container.children();
    this.currentImageNum=0;
    this.init(total,cssVar);
    clearInterval(interval);
    this.sliderProgrammi();
  }

  init(total, cssVar, paginator_cont) {

    if(total)  this.total = total;
    if(cssVar)  this.cssVar = cssVar;
    if(paginator_cont)  this.paginator_cont = paginator_cont;

    this.container.html('');
    if(total>1){
      this.createImages(0);
    }else{
      this.createImages(1);
    }
    this.createPallini(this.total, this.paginator_cont);

    try {
      this.addListeners();
    } catch (error) {
      $( window ).off('resize', this.onresize);
    }
  }
  createPallini(total, paginator){
      let template = `<ul class="h-list">`;
      for (let i = 0; i < total; i++) {
          let selected = i === 0 ? 'selected' : '';
          template += `<li data-idx="${i + 1}" class="paginator_square ${selected}"></li>`
      }
      template += `</ul>`;
      paginator.append(template);
  }

  createImages(num, item){
    return new Promise((resolve,reject)=>{

      $(this.swipeElementSelector).removeClass(this.slide_cont);
      $('.single_slide_home').removeClass('current');
      const initializing=this.container.children().length==0;
      let isBack=parseInt(getComputedStyle(document.documentElement).getPropertyValue(this.cssVar))<0;
      // root.style.setProperty(this.cssVar, 1);
      if(!item){
        if(!initializing &&isBack){
          $(this.container.children()[2]).remove();
          $(this.container.children()[1]).remove();
        }else if(!initializing){
          $(this.container.children()[1]).remove();
          $(this.container.children()[0]).remove();
        }
        this.container.css('transform','translate(0)');
        this.currentImageNum=num;
        const current=this.images[num];

        $(current).addClass('current');

        const prev=num==0?this.images[this.images.length-1]:this.images[num-1];
        const next=num==this.images.length-1?this.images[0]:this.images[num+1];
        if(initializing){
          this.container.append(current);
        }
        this.container.append(next);
        this.container.prepend(prev);
        if(this.total>1){
          this.container.css('transform','translate(-100%, 0)');
        }

      } else{
        $(this.container.children()).remove();
        // this.container.css('transform','translate(0)');
        this.currentImageNum=num;
        const current=this.images[num];
        this.container.append(current);
        $(current).addClass('current');
        const prev=num==0?this.images[this.images.length-1]:this.images[num-1];
        const next=num==this.images.length-1?this.images[0]:this.images[num+1];
        this.container.append(next);
        this.container.prepend(prev);
      }
      setTimeout(()=>{
          $(this.swipeElementSelector).addClass(this.slide_cont);
        resolve();
      },200);
    });
  }

  selectSlide(item){
    if($(item)[0].target.dataset.idx > $(".paginator_square.selected").data("idx")){
      this.doScroll(1, $(item)[0].target.dataset.idx);
    } else{
      this.doScroll(-1, $(item)[0].target.dataset.idx);
    }
    // console.log($(item)[0].target.dataset.idx);
    // let newNum=$(item)[0].target.dataset.idx;
    // root.style.setProperty(this.cssVar, 1);
    // this.container.css('transform','translate(-200%, 0)');
    // var titolo = $(this.images[newNum]).attr("data-titolo");
    // var date = $(this.images[newNum]).attr("data-date");
    // var categoria = $(this.images[newNum]).attr("data-categoria");
    // this.fillSlide(titolo, date, categoria);
    // $(".paginator_square").removeClass("selected");
    //
    // $(".paginator_square[data-idx='" + newNum + "']").addClass("selected");
    //
    //
    //
    // this.doScroll();
  }




  async doScroll(direction, item = ""){

    if(direction){
      if(scrollArr.length){
        scrollArr.push(()=>this.getScroll(direction, item));
        return;
      }
      scrollArr.push(()=>this.getScroll(direction, item));
    }else if(!scrollArr.length){
      return;
    }
    const _scrollArr=scrollArr.slice();

    for (let i = 0; i < 2; i++) {   /*limitare il numero di scrollamenti dati dal setInterval*/

      // console.log("scrollarr",_scrollArr.length);
      if(_scrollArr[i]){
        const promise = _scrollArr[i];
        const _start=new Date().getTime();
        await promise();
      }
    }

    scrollArr.splice(0, _scrollArr.length);
    this.doScroll();
  }

  getScroll(direction,item){
    let num=this.currentImageNum;

    return new Promise((resolve,reject)=>{
      let newNum=0;
      if(direction==-1){
        newNum=num==0?this.images.length-1:num-1;
        root.style.setProperty(this.cssVar, -1);
        if(item){
          newNum=parseInt(item) - 1;
        } else{
          this.container.css('transform','translate(0, 0)');
        }

      }else{
        newNum=num==this.images.length-1?0:num+1;
        root.style.setProperty(this.cssVar, 1);
        if(item){
          newNum=parseInt(item) - 1;
        } else{
          this.container.css('transform','translate(-200%, 0)');
        }

      }
        var titolo = $(this.images[newNum]).attr("data-titolo");
        var titolo_mobile = $(this.images[newNum]).attr("data-titolo-mobile");
        var date = $(this.images[newNum]).attr("data-date");
        var categoria = $(this.images[newNum]).attr("data-categoria");
        this.fillSlide(titolo, date, categoria, titolo_mobile);
        $(".paginator_square").removeClass("selected");
        var idx = newNum + 1;
        if(item){
          idx=parseInt(item);
        }

        $(".paginator_square[data-idx='" + idx + "']").addClass("selected");
      setTimeout(()=>{

        this.createImages(newNum, item).then(()=>{resolve()});
      },TRANSITION_DURATION);
    });
  }

  fillSlide(titolo, data, categoria,titolo_mobile){
      $(".fade_effect").fadeOut(function(){
          $("#titolo_current_slide").text(titolo);
          $("#titolo_current_slide_mobile").text(titolo_mobile);
          $("#categoria_current_slide").text(categoria);
          $("#data_current_slide").text(data);
          $(".fade_effect").fadeIn();
      });

  }

  addListeners() {
    if($('.single_slide_home').length>2){
      $(".slider_forward").on('click',()=>{this.doScroll(1)});
      $(".slider_backward").on('click',()=>{this.doScroll(-1)});
    }else if($('.single_slide_home').length>1){
      $(".slider_forward").on('click',()=>{this.doScroll(-1)});
      $(".slider_backward").on('click',()=>{this.doScroll(-1)});
    }else{
      $(".slider_forward").remove();
      $(".slider_backward").remove();
    }

    $(".paginator_square").on('click',(item)=>{

      this.selectSlide(item);
    });

      if(this.swipeElementSelector){
          const el = document.querySelector(this.swipeElementSelector);
          el.addEventListener('touchstart', (e) => {
              this.handleStart(e);
          }, {passive: true});
          el.addEventListener('touchend', (e) => { this.handleEnd(e); }, {passive: true});
          el.addEventListener('touchmove', (e) => { this.handleMove(e); }, {passive: true});
      }
  }

    handleStart(evt) {


        const touches = evt.changedTouches;
        data.xPos = touches[0].clientX;
        data.yPos = touches[0].clientY;
        data.partialXPos = 0;
        data.partialYPos = 0;
    }


    async handleMove(evt) {


        const element = evt.currentTarget;
        const touches = evt.changedTouches;
        const diffY = touches[0].clientY - data.yPos;
        const diffX = touches[0].clientX - data.xPos;
        let horizontalScroll = true;
        if (Math.abs(diffY) > Math.abs(diffX)) {
            horizontalScroll = false;
        }



        for (const key in DIRECTIONS) {
            const direction = DIRECTIONS[key];
            let diff = touches[0][direction.touchClient] - data[direction.pos];
            if (!horizontalScroll) {
                return;
            }
            evt.preventDefault();

            if (direction.checkHandleCondition(diff) && Math.abs(diff) >= TOLERANCE && !handling) {
                data[direction.pos] = touches[0][direction.touchClient];
                if(direction.name==='left'){
                    // $('.paginator.selected').next().click();
                    console.log("left");
                    handling = true;
                    await this.doScroll(1);
                    handling = false;

                }else{
                    // $('.paginator.selected').prev().click();
                    console.log("right");
                    handling = true;
                    await this.doScroll(-1);
                    handling = false;



                }
                // root.style.setProperty('--swipe-diff-h', `0px`);
                // root.style.setProperty('--swipe-diff-percentage-h', `0`);

            } else if (direction.checkHandleCondition(diff) && Math.abs(diff) < TOLERANCE) {
                diff = diff - data[direction.partialPos];
                // root.style.setProperty('--swipe-diff-h', `${diff}px`);
                // root.style.setProperty('--swipe-diff-percentage-h', `${diff / 100}`);
            }
        }
    }

    handleEnd(evt) {

        if (handling) {
            return;
        }
        const element = evt.currentTarget;
        // ADD CLASS
        // if (!config.removed) {
        //   element.style.transform = `translate3d(0, 0, 0)`;
        // }

        // root.style.setProperty('--swipe-diff-h', '0px');
        // root.style.setProperty('--swipe-diff-percentage-h', '0');
        // if (!data.removed) {
        //   element.style.transform = `translate3d(0, 0, 0)`;
        // }
        data.xPos = 0;
        data.yPos = 0;
    }
   sliderProgrammi(){
    let direction=1;
    if($('.single_slide_home').length<2){
      return;
    }
    if($('.single_slide_home').length<3){
      direction=-1;
    }
    var timerProgrammi = ()=>{
      if(interval){
        clearInterval(interval);
      }

      interval = setInterval(()=>{
        this.doScroll(direction);
      }, SLIDER_TIMING);
    };
    timerProgrammi();
    intervalInitiator = true;

     $(".paginator_square").on('click',(item)=>{
         clearInterval(interval);
         setTimeout(function(){
           timerProgrammi();
         }, 1000);
     });
     $(".arrow_slider button").on('click',(item)=>{
       clearInterval(interval);
       setTimeout(function(){
         timerProgrammi();
       }, 1000);
     });

     const el = document.querySelector(this.swipeElementSelector);
     el.addEventListener('touchstart', (e) => {
       clearInterval(interval);
       setTimeout(function(){
         timerProgrammi();
       }, 1000);
     }, {passive: true});
  }


}
export {Slider};
